import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "DocumentsModule"
const debug = false

export class DocumentsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.DOCUMENTS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Documents"
        this.description                = "Your tool for storing and managing documents across projects. Simply create, share and organize documents, providing your team with the information they need on one platform."
        this.svgIcon                    = "isvg-view-documents"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Productivity & Collaboration"
        this.settingsUrl                = "settings/documents"
        this.parentSection              = SettingsParentSection.PRODUCTIVITY

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}